import { createSlice } from '@reduxjs/toolkit'
import { ToastTypes } from 'features/Codes'

let i = 0

const toastSlice = createSlice({
  name: 'toast',
  initialState: {
    items: [],
  },
  reducers: {
    error(state, { payload: message }) {
      state.items = state.items.concat({
        id: i++,
        message,
        type: ToastTypes.FAIL,
      })
    },
    ok(state, { payload: message }) {
      state.items = state.items.concat({
        id: i++,
        message,
        type: ToastTypes.SUCCESS,
      })
    },
    show(state, { payload: { message, color } }) {
      state.items = state.items.concat({ id: i++, message, color })
    },
    hide(state, { payload: id }) {
      state.items = state.items.filter(item => item.id !== id)
    },
    clear(state) {
      state.items = []
    },
  },
})

export const Toasts = {
  show: toastSlice.actions.show,
  fail: toastSlice.actions.error,
  success: toastSlice.actions.ok,
  hide: toastSlice.actions.hide,
  clear: toastSlice.actions.clear,
}

export default toastSlice.reducer
